import { styled, EmotionComponent } from "../../styled";
import { hoverColorProp, HoverColorProp } from "../../utils";
import { OverrideNativeElementProps } from "../../utils/styleFn";
import { ButtonBaseProps, Button } from "./index";

export type LinkButtonProps = OverrideNativeElementProps<
  ButtonBaseProps & HoverColorProp,
  "a"
>;

export const LinkButton: EmotionComponent<LinkButtonProps> = styled(
  Button.withComponent("a")
)`
  display: inline-block;
  &:hover,
  &:focus {
    text-decoration: none;
    ${hoverColorProp}
  }
  &[disabled] {
    opacity: 0.7;
    cursor: not-allowed;
  }
`;

LinkButton.displayName = "LinkButton";

LinkButton.defaultProps = {
  variant: "primary",
  sizeVariant: "md",
  block: true,
  textTransform: "uppercase",
  hoverColor: "white",
  whiteSpace: "nowrap",
};

export default LinkButton;
